import {
  CLASS_getInstance3jy3ydw5832xx as CLASS_getInstance,
  STRINGrrr0wq2m1c2f as STRING,
  CLASS3e32wwn6b97hz as CLASS,
  MAPtg3mcyan4256 as MAP,
  LIST2gzos3vzn3slg as LIST,
  MAP_getInstance3e78m6vf98i66 as MAP_getInstance,
  LIST_getInstance2vniy0f7mmb29 as LIST_getInstance,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  equals2au1ep9vhcato as equals,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  protoOf180f3jzyo7rfj as protoOf,
  createThis2j2avj17cvnv2 as createThis,
  toString1pkumu07cwy4m as toString,
  setPropertiesToThrowableInstance1w2jjvl9y77yc as setPropertiesToThrowableInstance,
  captureStack1fzi4aczwc4hg as captureStack,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  get_isNullable36pbikm8xb7bz as get_isNullable,
  get_annotationshjxdbdcl8kmv as get_annotations,
  SerialDescriptor2pelqekb5ic3a as SerialDescriptor,
  get_isInline5x26qrhi9qs6 as get_isInline,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialDescriptor.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  Exceptiondt2hlxn7j7vw as Exception,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import {
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
  constructCallableReference23y65rf941mch as constructCallableReference,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { plus310ted5e4i90h as plus } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KClass1cc9rfeybg8hs as KClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KClassJs.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { EmptySerializersModule991ju6pz9b79 as EmptySerializersModule } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/modules/SerializersModuleBuilders.mjs';
import { serializer23irjhw2jlmhr as serializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/Serializers.mjs';
import { copyToArray2j022khrow2yi as copyToArray } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { ContextualSerializer1uidivg94sh5v as ContextualSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/ContextualSerializer.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import {
  get_nullable197rfua9r7fsz as get_nullable,
  serializer3u3hsxnenk49x as serializer_0,
  serializer1r0h5yakm679b as serializer_1,
  serializer1tw0a8bv7lkga as serializer_2,
  serializer1hu9wv9at41ww as serializer_3,
  serializerodflzzf6s3fp as serializer_4,
  serializer3x9uckd1deom as serializer_5,
  serializer1wpgysz06u9ol as serializer_6,
  serializer345btyh1f2y1j as serializer_7,
  serializer1x79l67jvwntn as serializer_8,
  NothingSerializer3oixyyf77l4xt as NothingSerializer,
  PairSerializer1d18kmsqyj4f as PairSerializer,
  TripleSerializer39fneesmgp1wy as TripleSerializer,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { SortPartSerializerr929bckmbnab as SortPartSerializer } from './SortPartSerializer.mjs';
import { DataClassPathSerializer2aqs8pcwb13zn as DataClassPathSerializer } from './DataClassPathSerializer.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { ConditionSerializer2v4zqxahhdocs as ConditionSerializer } from './ConditionSerialization.mjs';
import { ModificationSerializer36sautdazlmsc as ModificationSerializer } from './ModificationSerialization.mjs';
import { PartialSerializer3a1dmo3dlumfz as PartialSerializer } from './PartialSerializer.mjs';
import { AbstractDecoder35guh02ubh2hm as AbstractDecoder } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/encoding/AbstractDecoder.mjs';
import {
  BooleanCompanionObject_instance2tls5h1cufcrh as BooleanCompanionObject_instance,
  ByteCompanionObject_instance1r92wkzdy7g72 as ByteCompanionObject_instance,
  ShortCompanionObject_instance33mqksfmw0mrs as ShortCompanionObject_instance,
  IntCompanionObject_instance3g0jtywew2pgh as IntCompanionObject_instance,
  FloatCompanionObject_instanceokgc3apyetrg as FloatCompanionObject_instance,
  DoubleCompanionObject_instance43opzxl97v4p as DoubleCompanionObject_instance,
  StringCompanionObject_instance2dx16b5pp3v3z as StringCompanionObject_instance,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/primitiveCompanionObjects.mjs';
import { Companion_instancel8ig9z4updma as Companion_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Primitives.mjs';
import { Companion_getInstance1genqokpkr3uz as Companion_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Companion_getInstance12yez9f87gqg9 as Companion_getInstance_0 } from './SerializationRegistry.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_ANY() {
  _init_properties_SerializationHelpers_kt__7vf817();
  return ANY;
}
var ANY;
var pairSerialName;
var tripleSerialName;
var InliningSerialDescriptorClass;
function InliningSerialDescriptor() {
  if (InliningSerialDescriptorClass === VOID) {
    class $ {
      constructor(serialName, inner) {
        this.serialName_1 = serialName;
        this.inner_1 = inner;
        this.elementsCount_1 = 1;
      }
      get_serialName_u2rqhk_k$() {
        return this.serialName_1;
      }
      get_kind_wop7ml_k$() {
        return CLASS_getInstance();
      }
      get_elementsCount_288r0x_k$() {
        return this.elementsCount_1;
      }
      getElementName_u4sqmf_k$(index) {
        return 'value';
      }
      getElementIndex_utfbym_k$(name) {
        return name === 'value' ? 0 : -1;
      }
      getElementAnnotations_omrjs6_k$(index) {
        // Inline function 'kotlin.collections.listOf' call
        return emptyList();
      }
      getElementDescriptor_ncda77_k$(index) {
        return this.inner_1;
      }
      isElementOptional_heqq56_k$(index) {
        return false;
      }
      get_isInline_usk17w_k$() {
        return true;
      }
      equals(other) {
        var tmp;
        var tmp_0;
        if (other instanceof InliningSerialDescriptor()) {
          tmp_0 = other.serialName_1 === this.serialName_1;
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp = equals(other.inner_1, this.inner_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return imul(getStringHashCode(this.serialName_1), 31) + hashCode(this.inner_1) | 0;
      }
    }
    protoOf($).get_isNullable_67sy7o_k$ = get_isNullable;
    protoOf($).get_annotations_20dirp_k$ = get_annotations;
    initMetadataForClass($, 'InliningSerialDescriptor', VOID, VOID, [SerialDescriptor()]);
    InliningSerialDescriptorClass = $;
  }
  return InliningSerialDescriptorClass;
}
function error($this) {
  throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$('Primitive descriptor does not have elements');
}
var PrimitiveDescriptorWithAnnotationsClass;
function PrimitiveDescriptorWithAnnotations() {
  if (PrimitiveDescriptorWithAnnotationsClass === VOID) {
    class $ {
      constructor(serialName, kind, annotations) {
        this.serialName_1 = serialName;
        this.kind_1 = kind;
        this.annotations_1 = annotations;
      }
      get_serialName_u2rqhk_k$() {
        return this.serialName_1;
      }
      get_kind_wop7ml_k$() {
        return this.kind_1;
      }
      get_annotations_20dirp_k$() {
        return this.annotations_1;
      }
      get_elementsCount_288r0x_k$() {
        return 0;
      }
      getElementName_u4sqmf_k$(index) {
        error(this);
      }
      getElementIndex_utfbym_k$(name) {
        error(this);
      }
      isElementOptional_heqq56_k$(index) {
        error(this);
      }
      getElementDescriptor_ncda77_k$(index) {
        error(this);
      }
      getElementAnnotations_omrjs6_k$(index) {
        error(this);
      }
      toString() {
        return 'PrimitiveDescriptor(' + this.serialName_1 + ')';
      }
      equals(other) {
        var tmp;
        var tmp_0;
        var tmp_1;
        if (other instanceof PrimitiveDescriptorWithAnnotations()) {
          tmp_1 = other.serialName_1 === this.serialName_1;
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp_0 = equals(other.kind_1, this.kind_1);
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp = equals(other.annotations_1, this.annotations_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return (imul(getStringHashCode(this.serialName_1), 31) + imul(this.kind_1.hashCode(), 31) | 0) + hashCode(this.annotations_1) | 0;
      }
    }
    protoOf($).get_isNullable_67sy7o_k$ = get_isNullable;
    protoOf($).get_isInline_usk17w_k$ = get_isInline;
    initMetadataForClass($, 'PrimitiveDescriptorWithAnnotations', VOID, VOID, [SerialDescriptor()]);
    PrimitiveDescriptorWithAnnotationsClass = $;
  }
  return PrimitiveDescriptorWithAnnotationsClass;
}
var KSerializerKeyClass;
function KSerializerKey() {
  if (KSerializerKeyClass === VOID) {
    class $ {
      constructor(kSerializer, nullable) {
        return new.target.new_com_lightningkite_services_database_KSerializerKey_lrhpfn_k$(kSerializer, nullable);
      }
      static new_com_lightningkite_services_database_KSerializerKey_lrhpfn_k$(kSerializer, nullable) {
        var $this = createThis(this);
        $this.kSerializer_1 = kSerializer;
        $this.nullable_1 = nullable;
        var tmp = $this;
        var tmp0_safe_receiver = typeParametersSerializersOrNull2($this.kSerializer_1);
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.collections.map' call
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(tmp0_safe_receiver.length);
          var inductionVariable = 0;
          var last = tmp0_safe_receiver.length;
          while (inductionVariable < last) {
            var item = tmp0_safe_receiver[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            var tmp$ret$2 = KSerializerKey().new_com_lightningkite_services_database_KSerializerKey_4fta1q_k$(item);
            destination.add_utx5q5_k$(tmp$ret$2);
          }
          tmp_0 = destination;
        }
        var tmp1_elvis_lhs = tmp_0;
        var tmp_1;
        if (tmp1_elvis_lhs == null) {
          // Inline function 'kotlin.collections.listOf' call
          tmp_1 = emptyList();
        } else {
          tmp_1 = tmp1_elvis_lhs;
        }
        tmp.sub_1 = tmp_1;
        var tmp_2 = $this;
        var tmp0 = getKClassFromExpression($this.kSerializer_1).hashCode();
        // Inline function 'com.lightningkite.services.database.hashWith' call
        var other = hashCode($this.sub_1);
        var tmp0_0 = imul(tmp0, 31) + other | 0;
        // Inline function 'com.lightningkite.services.database.hashWith' call
        var other_0 = $this.kSerializer_1.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        var tmp0_1 = imul(tmp0_0, 31) + hashCode(other_0) | 0;
        // Inline function 'com.lightningkite.services.database.hashWith' call
        var other_1 = $this.nullable_1;
        tmp_2.storedHashCode_1 = imul(tmp0_1, 31) + hashCode(other_1) | 0;
        return $this;
      }
      static new_com_lightningkite_services_database_KSerializerKey_4fta1q_k$(kSerializer) {
        return this.new_com_lightningkite_services_database_KSerializerKey_lrhpfn_k$(kSerializer.get_descriptor_wjt6a0_k$().get_isNullable_67sy7o_k$() ? innerElement(kSerializer) : kSerializer, kSerializer.get_descriptor_wjt6a0_k$().get_isNullable_67sy7o_k$());
      }
      hashCode() {
        return this.storedHashCode_1;
      }
      equals(other) {
        var tmp;
        var tmp_0;
        var tmp_1;
        var tmp_2;
        if (other instanceof KSerializerKey()) {
          tmp_2 = this.kSerializer_1.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$() === other.kSerializer_1.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
        } else {
          tmp_2 = false;
        }
        if (tmp_2) {
          tmp_1 = this.nullable_1 === other.nullable_1;
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp_0 = getKClassFromExpression(this.kSerializer_1).equals(getKClassFromExpression(other.kSerializer_1));
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp = equals(this.sub_1, other.sub_1);
        } else {
          tmp = false;
        }
        return tmp;
      }
      toString() {
        return toString(this.kSerializer_1);
      }
    }
    initMetadataForClass($, 'KSerializerKey');
    KSerializerKeyClass = $;
  }
  return KSerializerKeyClass;
}
function _get_original__l7ku1m($this) {
  var tmp0 = $this.original$delegate_1;
  var tmp = KProperty1();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('original', 1, tmp, LazySerialDescriptor$_get_original_$ref_tbwck6(), null);
  return tmp0.get_value_j01efc_k$();
}
function LazySerialDescriptor$_get_original_$ref_tbwck6() {
  return constructCallableReference((p0) => _get_original__l7ku1m(p0), 1, 0, 149);
}
function LazySerialDescriptor$_get_annotations_$ref_44gmkx() {
  return constructCallableReference((p0) => p0.get_annotations_20dirp_k$(), 1, 0, 150);
}
var LazySerialDescriptorClass;
function LazySerialDescriptor() {
  if (LazySerialDescriptorClass === VOID) {
    class $ {
      constructor(serialName, kind, additionalAnnotations, deferred) {
        kind = kind === VOID ? null : kind;
        var tmp;
        if (additionalAnnotations === VOID) {
          // Inline function 'kotlin.collections.listOf' call
          tmp = emptyList();
        } else {
          tmp = additionalAnnotations;
        }
        additionalAnnotations = tmp;
        this.serialName_1 = serialName;
        this.additionalAnnotations_1 = additionalAnnotations;
        this.original$delegate_1 = lazy(deferred);
        this.explicitKind_1 = kind;
        var tmp_0 = this;
        tmp_0.annotations$delegate_1 = lazy(() => plus(_get_original__l7ku1m(this).get_annotations_20dirp_k$(), this.additionalAnnotations_1));
      }
      get_serialName_u2rqhk_k$() {
        return this.serialName_1;
      }
      get_kind_wop7ml_k$() {
        var tmp0_elvis_lhs = this.explicitKind_1;
        return tmp0_elvis_lhs == null ? _get_original__l7ku1m(this).get_kind_wop7ml_k$() : tmp0_elvis_lhs;
      }
      get_elementsCount_288r0x_k$() {
        return _get_original__l7ku1m(this).get_elementsCount_288r0x_k$();
      }
      getElementName_u4sqmf_k$(index) {
        return _get_original__l7ku1m(this).getElementName_u4sqmf_k$(index);
      }
      getElementIndex_utfbym_k$(name) {
        return _get_original__l7ku1m(this).getElementIndex_utfbym_k$(name);
      }
      getElementAnnotations_omrjs6_k$(index) {
        return _get_original__l7ku1m(this).getElementAnnotations_omrjs6_k$(index);
      }
      getElementDescriptor_ncda77_k$(index) {
        return _get_original__l7ku1m(this).getElementDescriptor_ncda77_k$(index);
      }
      isElementOptional_heqq56_k$(index) {
        return _get_original__l7ku1m(this).isElementOptional_heqq56_k$(index);
      }
      get_annotations_20dirp_k$() {
        var tmp0 = this.annotations$delegate_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, LazySerialDescriptor$_get_annotations_$ref_44gmkx(), null);
        return tmp0.get_value_j01efc_k$();
      }
      get_isInline_usk17w_k$() {
        return _get_original__l7ku1m(this).get_isInline_usk17w_k$();
      }
      get_isNullable_67sy7o_k$() {
        return _get_original__l7ku1m(this).get_isNullable_67sy7o_k$();
      }
      equals(other) {
        var tmp;
        if (other instanceof LazySerialDescriptor()) {
          tmp = equals(_get_original__l7ku1m(other), _get_original__l7ku1m(this));
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(_get_original__l7ku1m(this));
      }
    }
    initMetadataForClass($, 'LazySerialDescriptor', VOID, VOID, [SerialDescriptor()]);
    LazySerialDescriptorClass = $;
  }
  return LazySerialDescriptorClass;
}
function serializerOrContextual(type) {
  _init_properties_SerializationHelpers_kt__7vf817();
  // Inline function 'kotlin.collections.map' call
  var this_0 = type.get_arguments_p5ddub_k$();
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var item = _iterator__ex2g4s.next_20eer_k$();
    var tmp$ret$2 = serializerOrContextual(ensureNotNull(item.type_1));
    destination.add_utx5q5_k$(tmp$ret$2);
  }
  var args = destination;
  var tmp = type.get_classifier_ottyl2_k$();
  var kclass = (!(tmp == null) ? isInterface(tmp, KClass()) : false) ? tmp : THROW_CCE();
  var tmp_0;
  try {
    tmp_0 = serializer(EmptySerializersModule(), kclass, args, type.get_isMarkedNullable_4el8ow_k$());
  } catch ($p) {
    var tmp_1;
    if ($p instanceof SerializationException()) {
      var e = $p;
      // Inline function 'kotlin.collections.toTypedArray' call
      var tmp$ret$3 = copyToArray(args);
      // Inline function 'kotlin.let' call
      var it = ContextualSerializer().new_kotlinx_serialization_ContextualSerializer_niymzz_k$(kclass, null, tmp$ret$3);
      var tmp_2;
      if (type.get_isMarkedNullable_4el8ow_k$()) {
        tmp_2 = get_nullable(isInterface(it, KSerializer()) ? it : THROW_CCE());
      } else {
        tmp_2 = it;
      }
      tmp_1 = tmp_2;
    } else {
      throw $p;
    }
    tmp_0 = tmp_1;
  }
  return tmp_0;
}
function innerElement(_this__u8e3s4) {
  _init_properties_SerializationHelpers_kt__7vf817();
  var tmp;
  try {
    var tmp_0;
    if (_this__u8e3s4 instanceof WrappingSerializer()) {
      tmp_0 = innerElement(_this__u8e3s4.get_to_kntnng_k$());
    } else {
      _this__u8e3s4.deserialize_sy6x50_k$(new (CheatingBastardDecoder())(0));
      throw Exception().new_kotlin_Exception_hsqbop_k$(_this__u8e3s4.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$() + ' (' + toString(_this__u8e3s4) + ') did not have an inner element');
    }
    tmp = tmp_0;
  } catch ($p) {
    var tmp_1;
    if ($p instanceof FoundSerializerSignal()) {
      var e = $p;
      tmp_1 = e.serializer_1;
    } else {
      throw $p;
    }
    tmp = tmp_1;
  }
  return tmp;
}
function typeParametersSerializersOrNull2(_this__u8e3s4) {
  _init_properties_SerializationHelpers_kt__7vf817();
  var tmp0_subject = _this__u8e3s4.get_descriptor_wjt6a0_k$().get_kind_wop7ml_k$();
  var tmp;
  if (tmp0_subject instanceof LIST()) {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = [innerElement(_this__u8e3s4)];
  } else {
    if (tmp0_subject instanceof MAP()) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = [innerElement2(_this__u8e3s4)];
    } else {
      if (tmp0_subject instanceof CLASS()) {
        var tmp1_safe_receiver = isInterface(_this__u8e3s4, GeneratedSerializer()) ? _this__u8e3s4 : null;
        var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.typeParametersSerializers_fr94fx_k$();
        var tmp_0;
        if (tmp2_elvis_lhs == null) {
          var tmp3_safe_receiver = _this__u8e3s4 instanceof ConditionSerializer() ? _this__u8e3s4 : null;
          var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.inner_1;
          var tmp_1;
          if (tmp4_safe_receiver == null) {
            tmp_1 = null;
          } else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.arrayOf' call
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            tmp_1 = [tmp4_safe_receiver];
          }
          tmp_0 = tmp_1;
        } else {
          tmp_0 = tmp2_elvis_lhs;
        }
        var tmp5_elvis_lhs = tmp_0;
        var tmp_2;
        if (tmp5_elvis_lhs == null) {
          var tmp6_safe_receiver = _this__u8e3s4 instanceof ModificationSerializer() ? _this__u8e3s4 : null;
          var tmp7_safe_receiver = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.inner_1;
          var tmp_3;
          if (tmp7_safe_receiver == null) {
            tmp_3 = null;
          } else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.arrayOf' call
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            tmp_3 = [tmp7_safe_receiver];
          }
          tmp_2 = tmp_3;
        } else {
          tmp_2 = tmp5_elvis_lhs;
        }
        var tmp8_elvis_lhs = tmp_2;
        var tmp_4;
        if (tmp8_elvis_lhs == null) {
          var tmp9_safe_receiver = _this__u8e3s4 instanceof PartialSerializer() ? _this__u8e3s4 : null;
          var tmp10_safe_receiver = tmp9_safe_receiver == null ? null : tmp9_safe_receiver.source_1;
          var tmp_5;
          if (tmp10_safe_receiver == null) {
            tmp_5 = null;
          } else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.arrayOf' call
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            tmp_5 = [tmp10_safe_receiver];
          }
          tmp_4 = tmp_5;
        } else {
          tmp_4 = tmp8_elvis_lhs;
        }
        tmp = tmp_4;
      } else {
        if (tmp0_subject instanceof STRING()) {
          var tmp11_safe_receiver = _this__u8e3s4 instanceof SortPartSerializer() ? _this__u8e3s4 : null;
          var tmp12_safe_receiver = tmp11_safe_receiver == null ? null : tmp11_safe_receiver.inner_1;
          var tmp_6;
          if (tmp12_safe_receiver == null) {
            tmp_6 = null;
          } else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.arrayOf' call
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            tmp_6 = [tmp12_safe_receiver];
          }
          var tmp13_elvis_lhs = tmp_6;
          var tmp_7;
          if (tmp13_elvis_lhs == null) {
            var tmp14_safe_receiver = _this__u8e3s4 instanceof DataClassPathSerializer() ? _this__u8e3s4 : null;
            var tmp15_safe_receiver = tmp14_safe_receiver == null ? null : tmp14_safe_receiver.inner_1;
            var tmp_8;
            if (tmp15_safe_receiver == null) {
              tmp_8 = null;
            } else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.arrayOf' call
              // Inline function 'kotlin.js.unsafeCast' call
              // Inline function 'kotlin.js.asDynamic' call
              tmp_8 = [tmp15_safe_receiver];
            }
            tmp_7 = tmp_8;
          } else {
            tmp_7 = tmp13_elvis_lhs;
          }
          tmp = tmp_7;
        } else {
          tmp = null;
        }
      }
    }
  }
  return tmp;
}
function WrappingSerializer$_get_to_$ref_wby5yt() {
  return constructCallableReference((p0) => p0.get_to_kntnng_k$(), 1, 0, 151);
}
var WrappingSerializerClass;
function WrappingSerializer() {
  if (WrappingSerializerClass === VOID) {
    class $ {
      constructor(name) {
        this.name_1 = name;
        var tmp = this;
        tmp.to$delegate_1 = lazy(() => this.getDeferred_py8w4r_k$());
        var tmp_0 = this;
        tmp_0.descriptor_1 = new (LazySerialDescriptor())(this.name_1, VOID, VOID, () => this.get_to_kntnng_k$().get_descriptor_wjt6a0_k$());
      }
      get_to_kntnng_k$() {
        var tmp0 = this.to$delegate_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('to', 1, tmp, WrappingSerializer$_get_to_$ref_wby5yt(), null);
        return tmp0.get_value_j01efc_k$();
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      deserialize_sy6x50_k$(decoder) {
        return this.outer_ojvjpq_k$(decoder.decodeSerializableValue_xpnpad_k$(this.get_to_kntnng_k$()));
      }
      serialize_fx3111_k$(encoder, value) {
        return encoder.encodeSerializableValue_3uuzip_k$(this.get_to_kntnng_k$(), this.inner_edgipe_k$(value));
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_fx3111_k$(encoder, value);
      }
    }
    initMetadataForClass($, 'WrappingSerializer', VOID, VOID, [KSerializer()]);
    WrappingSerializerClass = $;
  }
  return WrappingSerializerClass;
}
var CheatingBastardDecoderClass;
function CheatingBastardDecoder() {
  if (CheatingBastardDecoderClass === VOID) {
    class $ extends AbstractDecoder() {
      constructor(count, serializersModule) {
        count = count === VOID ? 0 : count;
        serializersModule = serializersModule === VOID ? EmptySerializersModule() : serializersModule;
        super();
        this.count_1 = count;
        this.serializersModule_1 = serializersModule;
        this.counter_1 = 0;
      }
      get_serializersModule_piitvg_k$() {
        return this.serializersModule_1;
      }
      decodeElementIndex_bstkhp_k$(descriptor) {
        var _unary__edvuaz = this.counter_1;
        this.counter_1 = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.let' call
        return _unary__edvuaz >= descriptor.get_elementsCount_288r0x_k$() ? -1 : _unary__edvuaz;
      }
      decodeSerializableValue_xpnpad_k$(deserializer) {
        if (this.count_1 === 0) {
          throw new (FoundSerializerSignal())(isInterface(deserializer, KSerializer()) ? deserializer : THROW_CCE());
        }
        this.count_1 = this.count_1 - 1 | 0;
        return get_ANY();
      }
      decodeBoolean_m0aca_k$() {
        throw new (FoundSerializerSignal())(serializer_0(BooleanCompanionObject_instance));
      }
      decodeByte_jzz7je_k$() {
        throw new (FoundSerializerSignal())(serializer_1(ByteCompanionObject_instance));
      }
      decodeShort_jjqk32_k$() {
        throw new (FoundSerializerSignal())(serializer_2(ShortCompanionObject_instance));
      }
      decodeInt_8iq8f5_k$() {
        throw new (FoundSerializerSignal())(serializer_3(IntCompanionObject_instance));
      }
      decodeLong_jzt186_k$() {
        throw new (FoundSerializerSignal())(serializer_4(Companion_instance));
      }
      decodeFloat_jcnrwu_k$() {
        throw new (FoundSerializerSignal())(serializer_5(FloatCompanionObject_instance));
      }
      decodeDouble_ur8l0f_k$() {
        throw new (FoundSerializerSignal())(serializer_6(DoubleCompanionObject_instance));
      }
      decodeChar_dcmcfa_k$() {
        throw new (FoundSerializerSignal())(serializer_7(Companion_getInstance()));
      }
      decodeString_x3hxsx_k$() {
        throw new (FoundSerializerSignal())(serializer_8(StringCompanionObject_instance));
      }
      decodeEnum_slg6lu_k$(enumDescriptor) {
        var tmp = Companion_getInstance_0().master_1;
        var tmp_0 = enumDescriptor.get_serialName_u2rqhk_k$();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$0 = [];
        throw new (FoundSerializerSignal())(ensureNotNull(tmp.get_yiwm6c_k$(tmp_0, tmp$ret$0)));
      }
    }
    initMetadataForClass($, 'CheatingBastardDecoder', CheatingBastardDecoder);
    CheatingBastardDecoderClass = $;
  }
  return CheatingBastardDecoderClass;
}
var FoundSerializerSignalClass;
function FoundSerializerSignal() {
  if (FoundSerializerSignalClass === VOID) {
    class $ extends Error {
      constructor(serializer) {
        super(null);
        setPropertiesToThrowableInstance(this);
        captureStack(this, this.$throwableCtor_1);
        this.serializer_1 = serializer;
      }
    }
    initMetadataForClass($, 'FoundSerializerSignal');
    FoundSerializerSignalClass = $;
  }
  return FoundSerializerSignalClass;
}
function innerElement2(_this__u8e3s4) {
  _init_properties_SerializationHelpers_kt__7vf817();
  var tmp;
  try {
    var tmp_0;
    if (_this__u8e3s4 instanceof WrappingSerializer()) {
      tmp_0 = innerElement2(_this__u8e3s4.get_to_kntnng_k$());
    } else {
      _this__u8e3s4.deserialize_sy6x50_k$(new (CheatingBastardDecoder())(1));
      throw Exception().new_kotlin_Exception_hsqbop_k$(_this__u8e3s4.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$() + ' (' + toString(_this__u8e3s4) + ') did not have a second inner element');
    }
    tmp = tmp_0;
  } catch ($p) {
    var tmp_1;
    if ($p instanceof FoundSerializerSignal()) {
      var e = $p;
      tmp_1 = e.serializer_1;
    } else {
      throw $p;
    }
    tmp = tmp_1;
  }
  return tmp;
}
function nullElement(_this__u8e3s4) {
  _init_properties_SerializationHelpers_kt__7vf817();
  return _this__u8e3s4.get_descriptor_wjt6a0_k$().get_isNullable_67sy7o_k$() ? innerElement(_this__u8e3s4) : null;
}
function mapValueElement(_this__u8e3s4) {
  _init_properties_SerializationHelpers_kt__7vf817();
  return equals(_this__u8e3s4.get_descriptor_wjt6a0_k$().get_kind_wop7ml_k$(), MAP_getInstance()) ? innerElement2(_this__u8e3s4) : null;
}
function listElement(_this__u8e3s4) {
  _init_properties_SerializationHelpers_kt__7vf817();
  return equals(_this__u8e3s4.get_descriptor_wjt6a0_k$().get_kind_wop7ml_k$(), LIST_getInstance()) ? innerElement(_this__u8e3s4) : null;
}
function mapKeyElement(_this__u8e3s4) {
  _init_properties_SerializationHelpers_kt__7vf817();
  return equals(_this__u8e3s4.get_descriptor_wjt6a0_k$().get_kind_wop7ml_k$(), MAP_getInstance()) ? innerElement(_this__u8e3s4) : null;
}
var properties_initialized_SerializationHelpers_kt_s7qwyf;
function _init_properties_SerializationHelpers_kt__7vf817() {
  if (!properties_initialized_SerializationHelpers_kt_s7qwyf) {
    properties_initialized_SerializationHelpers_kt_s7qwyf = true;
    ANY = new Object();
    pairSerialName = PairSerializer(NothingSerializer(), NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
    tripleSerialName = TripleSerializer(NothingSerializer(), NothingSerializer(), NothingSerializer()).get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$();
  }
}
//region block: exports
export {
  InliningSerialDescriptor as InliningSerialDescriptoruyfh24595vup,
  KSerializerKey as KSerializerKey32hf92q4tsy3p,
  LazySerialDescriptor as LazySerialDescriptor3enjj1xzeog28,
  PrimitiveDescriptorWithAnnotations as PrimitiveDescriptorWithAnnotations1b27un5ddu1g9,
  WrappingSerializer as WrappingSerializer1aufse1qyl29g,
  innerElement2 as innerElement222h68gtcj2a37,
  innerElement as innerElement14z17r4weewi9,
  listElement as listElement3jy3tr2z6og1q,
  mapKeyElement as mapKeyElement31sqd0eg9e6zl,
  mapValueElement as mapValueElementnslktw4l3iup,
  nullElement as nullElement39ujy5fzowmto,
  serializerOrContextual as serializerOrContextual2mm942ha7plg6,
};
//endregion

//# sourceMappingURL=SerializationHelpers.mjs.map
